import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DataSharingService} from '../services/data-sharing.service';
import {SectorEnum} from '../modals/SectorEnum';
import {SubSectorEnum} from '../modals/SubSectorEnum';
import {UtilService} from '../services/UtilService';
import {Store} from '@ngxs/store';
import {UpdateFilter} from '../ngxs/screener-filter.action';
import {ScreenerFilter} from '../modals/ScreenerFilter';
import {Filters} from '../modals/Filters';

@Component({
  selector: 'app-screener-filters',
  templateUrl: './screener-filters.component.html',
  styleUrls: ['./screener-filters.component.scss']
})
export class ScreenerFiltersComponent implements OnInit {

  @Input() indexType = '';
  @Output() shareFilter = new EventEmitter<any>();
  @Output() filterStatus = new EventEmitter<any>();
  filterMap = new Map<string, any>();

  maturityData = ['(unassigned)', '1-3 years', '1-5 years', '1-10 years', '1-15 years', '1-20 years', '3-5 years',
    '5-7 years', '5-10 years', '5-15 years', '5 years plus', '7-10 years', '7 years plus', '10-15 years', '10 years plus', '15-20 years',
    '15-25 years', '15 years plus', '20-25 years', '25-30 years', '25 years plus', '30 years plus'];
  maturityMapping = {
    '(unassigned)': '(unassigned)',
    '1-3 years': 'years1To3',
    '1-5 years': 'years1To5',
    '1-10 years': 'years1To10',
    '1-15 years': 'years1To15',
    '1-20 years': 'years1To20',
    '3-5 years': 'years3To5',
    '5-7 years': 'years5To7',
    '5-10 years': 'years5To10',
    '5-15 years': 'years5To15',
    '5 years plus': 'years5Plus',
    '7-10 years': 'years7To10',
    '7 years plus': 'years7Plus',
    '10-15 years': 'years10To15',
    '10 years plus': 'years10Plus',
    '15-20 years': 'years15To20',
    '15-25 years': 'years15To25',
    '15 years plus': 'years15Plus',
    '20-25 years': 'years20To25',
    '25-30 years': 'years25To30',
    '25 years plus': 'years25Plus',
    '30 years plus': 'years30Plus'
  };
  investmentTypeMapping = {
    '(unassigned)': '(unassigned)',
    Liquid: 'Liquid',
    Short: 'Short',
    Broad: 'Broad',
    ESG_Sustainable: 'ESG/Sustainable',
    Standardized_TRS: 'Standardized TRS',
    Futures: 'Futures',
    ETFs_FUNDs: 'ETFs/Funds',
    Smart_Beta_Strategy: 'Smart Beta/Strategy'};
  ratingData = ['AAA', 'AA', 'A', 'BBB', 'BB', 'B', 'CCC', 'CC', 'C', 'Investment Grade', 'High Yield', '*'];
  families: any;
  familiesResultCount = -1;
  maturity: any;
  maturityResultCount = -1;
  rating: any;
  ratingResultCount = -1;
  region: any;
  regionResultCount = -1;
  masterID = '';
  masterIDCount = -1;
  indexName = '';
  indexNameCount = -1;
  currency: any;
  currencyResultCount = -1;
  fxVersion: any;
  fxVersionResultCount = -1;
  investmentType: any;
  investmentTypeResultCount = -1;
  sector: any;
  sectorResultCount = -1;
  subSector: any;
  subSectorResultCount = -1;

  filter = {};
  hasFilter = false;
  refreshFilters = true;
  timeout: any = null;

  constructor(private shareService: DataSharingService, private utilService: UtilService, private store: Store) {
  }

  ngOnInit(): void {
    this.store.select(state => state.screenerFilters.screenerFilters).subscribe((resp: any) => {
      if (resp) {
        const storedFilter = resp[this.indexType];
        this.filterMap.clear();
        if (Object.keys(storedFilter).length > 0) {
          Object.keys(storedFilter).forEach((key: string) => {
            this.filterMap.set(key, storedFilter[key]);
          });
          this.shareFilter.emit(storedFilter);
          this.shareService.filterApplied = Object.keys(storedFilter).length > 0;
        }
        this.shareService.filteredMap = this.filterMap;
        this.hasFilter = Object.keys(storedFilter).length > 0;
        this.sortFilters();
      }
    });
    this.initialiseDropDowns();
    this.getFilters();
  }

  initDropDowns(filter: any): void {
    this.initialiseDropDowns();
    let filterString: string[];
    const filterSub = this.shareService.filters.subscribe((resp: any) => {
      if (this.shareService.filterApplied) {
        if (this.shareService.filteredMap.get('masterID') != null ||
          this.shareService.filteredMap.get('masterID') !== undefined) {
          this.masterID = this.shareService.filteredMap.get('masterID');
          // @ts-ignore
          this.filter.masterID = this.shareService.filteredMap.get('masterID');
        }
        if (this.shareService.filteredMap.get('indexName') != null ||
          this.shareService.filteredMap.get('indexName') !== undefined) {
          this.indexName = this.shareService.filteredMap.get('indexName');
          // @ts-ignore
          this.filter.indexName = this.shareService.filteredMap.get('indexName');
        }
      }
      this.families.options = [];
      for (const data of resp.indexFamily) {
        let selectedVal = false;
        if (this.shareService.filterApplied) {
          if (this.shareService.filteredMap.get('indexFamily') != null ||
            this.shareService.filteredMap.get('indexFamily') !== undefined) {
            // @ts-ignore
            this.filter.indexFamily = this.shareService.filteredMap.get('indexFamily');
            filterString = this.shareService.filteredMap.get('indexFamily').split('~');
            for (const familyValue of filterString) {
              if (data === familyValue) {
                selectedVal = true;
                break;
              }
            }
          }
        }
        this.families.options.push({
          label: data,
          value: data,
          selected: selectedVal
        });
      }
      this.currency.options = [];
      for (const data of resp.indexCurrency) {
        let selectedVal = false;
        if (this.shareService.filterApplied) {
          if (this.shareService.filteredMap.get('indexCurrency') != null ||
            this.shareService.filteredMap.get('indexCurrency') !== undefined) {
            // @ts-ignore
            this.filter.indexCurrency = this.shareService.filteredMap.get('indexCurrency');
            filterString = this.shareService.filteredMap.get('indexCurrency').split('~');
            for (const currencyValue of filterString) {
              if (data === currencyValue) {
                selectedVal = true;
                break;
              }
            }
          }
        }
        this.currency.options.push({
          label: data,
          value: data,
          selected: selectedVal
        });
      }
      if (!window.location.href.includes('EMIX')) {
        this.region.options = [];
        for (const data of resp.region) {
          let selectedVal = false;
          if (this.shareService.filterApplied) {
            if (this.shareService.filteredMap.get('region') != null || this.shareService.filteredMap.get('region') !== undefined) {
              // @ts-ignore
              this.filter.region = this.shareService.filteredMap.get('region');
              filterString = this.shareService.filteredMap.get('region').split('~');
              for (const savedVal of filterString) {
                if (data === savedVal.split('_').join(' ')) {
                  selectedVal = true;
                  break;
                }
              }
            }
          }

          this.region.options.push({
            label: data,
            value: data,
            selected: selectedVal
          });
        }
        this.investmentType.options = [];
        if (this.indexType === 'all') {
          for (let data of resp.investmentType) {
            // @ts-ignore
            data = this.investmentTypeMapping[data];
            let selectedVal = false;
            if (this.shareService.filterApplied) {
              if (this.shareService.filteredMap.get('investmentType') != null ||
                this.shareService.filteredMap.get('investmentType') !== undefined) {
                // @ts-ignore
                this.filter.investmentType = this.shareService.filteredMap.get('investmentType');
                filterString = this.shareService.filteredMap.get('investmentType').split('~');
                for (const savedVal of filterString) {
                  if (data.split('/').join('_').split(' ').join('_') === savedVal) {
                    selectedVal = true;
                    break;
                  }
                }
              }
            }

            this.investmentType.options.push({
              label: data,
              value: data,
              selected: selectedVal
            });
          }
        } else {
          let data = '';
          switch (this.indexType) {
            case 'futures':
              data = 'Futures';
              break;
            case 'trs':
              data = 'Standardized TRS';
              break;
            case 'esg':
              data = 'ESG/Sustainable';
              break;
          }
          this.investmentType.options.push({
            label: data,
            value: data,
            selected: true
          });
        }
      }
    });

    if (filterSub){
      filterSub.unsubscribe();
    }
    if (this.indexType !== 'emix'){
      for (const data of this.maturityData) {
        let selectedVal = false;
        if (this.shareService.filterApplied) {
          if (this.shareService.filteredMap.get('maturity') != null || this.shareService.filteredMap.get('maturity') !== undefined) {
            // @ts-ignore
            this.filter.maturity = this.shareService.filteredMap.get('maturity');
            filterString = this.shareService.filteredMap.get('maturity').split('~');
            for (const savedVal of filterString) {
              if (data === this.getValue(savedVal)) {
                selectedVal = true;
                break;
              }
            }
          }
        }
        this.maturity.options.push({
          label: data,
          value: data,
          selected: selectedVal
        });
      }
      filter.maturity = [];
      Object.keys(this.maturityMapping).forEach((key: any) => {
        // @ts-ignore
        filter.maturity.push(this.maturityMapping[key]);
      });

      for (const data of this.shareService.fxVersionFilter) {
        let selectedVal = false;
        if (this.shareService.filterApplied) {
          if (this.shareService.filteredMap.get('fxVersion') != null || this.shareService.filteredMap.get('fxVersion') !== undefined) {
            // @ts-ignore
            this.filter.fxVersion = this.shareService.filteredMap.get('fxVersion');
            filterString = this.shareService.filteredMap.get('fxVersion').split('~');
            for (const ratingVal of filterString) {
              if (data === ratingVal) {
                selectedVal = true;
                break;
              }
            }
          }
        }
        this.fxVersion.options.push({
          label: data,
          value: data,
          selected: selectedVal
        });
      }
      filter.rating = [];
      for (const data of this.ratingData) {
        let selectedVal = false;
        if (this.shareService.filterApplied) {
          if (this.shareService.filteredMap.get('rating') != null || this.shareService.filteredMap.get('rating') !== undefined) {
            // @ts-ignore
            this.filter.rating = this.shareService.filteredMap.get('rating');
            filterString = this.shareService.filteredMap.get('rating').split('~');
            for (const ratingVal of filterString) {
              if (data === ratingVal) {
                selectedVal = true;
                break;
              }
            }
          }
        }
        this.rating.options.push({
          label: data,
          value: data,
          selected: selectedVal
        });
        filter.rating.push(data);
      }
      filter.sector = [];
      Object.keys(SectorEnum).forEach((key: string) => {
        let selectedVal = false;
        // @ts-ignore
        const value = SectorEnum[key];
        if (this.shareService.filterApplied) {
          if (this.shareService.filteredMap.get('sector') != null || this.shareService.filteredMap.get('sector') !== undefined) {
            // @ts-ignore
            this.filter.sector = this.shareService.filteredMap.get('sector');
            filterString = this.shareService.filteredMap.get('sector').split('~');
            for (const sectorValue of filterString) {
              if (value === sectorValue) {
                selectedVal = true;
                break;
              }
            }
          }
        }
        this.sector.options.push({
          label: value,
          value,
          selected: selectedVal
        });
        filter.sector.push(value);
      });
      filter.subSector = [];
      Object.keys(SubSectorEnum).forEach((key: string) => {
        // @ts-ignore
        const data = SubSectorEnum[key];
        let selectedVal = false;
        if (this.shareService.filterApplied) {
          if (this.shareService.filteredMap.get('subSector') != null || this.shareService.filteredMap.get('subSector') !== undefined) {
            // @ts-ignore
            this.filter.subSector = this.shareService.filteredMap.get('subSector');
            filterString = this.shareService.filteredMap.get('subSector').split('~');
            for (const subSectorValue of filterString) {
              if (data === subSectorValue) {
                selectedVal = true;
                break;
              }
            }
          }
        }
        this.subSector.options.push({
          label: data,
          value: data,
          selected: selectedVal
        });
        filter.subSector.push(data);
      });
    }

    this.sortFilters();
    this.getResultCount(filter, '');
    setTimeout(() => {this.refreshFilters = true; }, 10);
  }

  getFilters(): void {
    const filterSub = this.shareService.screenerFilters.subscribe((filter: any) => {
      this.initDropDowns(filter);
    });

    if (filterSub) {
      filterSub.unsubscribe();
    }
  }

  getFilterForKey(key: string): void {
    const filterSub = this.shareService.screenerFilters.subscribe((filter: any) => {
      this.getResultCount(filter, key);
    });

    if (filterSub) {
      filterSub.unsubscribe();
    }
  }

  getResultCount(filter: any, key: string): void {
    const batchSub = this.shareService.filteredBatchData.subscribe((data: any) => {
      if (filter.rating || key === 'rating') {
        this.ratingResultCount = this.utilService.getRecordsForRating(filter.rating.join('~'), data).length;
      }
      if (filter.indexCurrency || key === 'indexCurrency') {
        if (this.indexType === 'emix'){
          // @ts-ignore
          this.currencyResultCount = this.utilService.getRecordsForCurrencyForEMIX(this.filter.indexCurrency, data).length;
        }else {
          // @ts-ignore
          this.currencyResultCount = this.utilService.getRecordsForIndexCurrency(this.filter.indexCurrency, data).length;
        }
      }
      if (filter.fxVersion || key === 'fxVersion') {
        // @ts-ignore
        this.fxVersionResultCount = this.utilService.getRecordsForBaseCurrency(this.filter.fxVersion, data).length;
      }
      if (filter.maturity || key === 'maturity') {
        // @ts-ignore
        this.maturityResultCount = this.utilService.getRecordsForMaturity(this.filter.maturity, data).length;
      }
      if (filter.indexFamily || key === 'indexFamily') {
        if (this.indexType === 'emix'){
          // @ts-ignore
          this.familiesResultCount = this.utilService.getRecordsForIndexFamilyForEMIX(this.filter.indexFamily, data).length;
        }else {
          // @ts-ignore
          this.familiesResultCount = this.utilService.getRecordsForIndexFamily(this.filter.indexFamily, data).length;
        }
      }
      if (filter.region || key === 'region') {
        // @ts-ignore
        this.regionResultCount = this.utilService.getRecordsForRegion(this.filter.region, data).length;
      }
      if (filter.investmentType || key === 'investmentType') {
        // @ts-ignore
        this.investmentTypeResultCount = this.utilService.getRecordsForInvestmentType(this.filter.investmentType, data).length;
      }
      if (filter.sector || key === 'sector') {
        // @ts-ignore
        this.sectorResultCount = this.utilService.getRecordsForSector(this.filter.sector, data).length;
      }
      if (filter.subSector || key === 'subSector') {
        // @ts-ignore
        this.subSectorResultCount = this.utilService.getRecordsForSubSector(this.filter.subSector, data).length;
      }
      if (filter.masterID || key === 'masterID'){
        this.masterIDCount = this.utilService.getRecordsForMasterIDForEMIX(filter.masterID.join('~'), data).length;
      }
      if (filter.indexName || key === 'indexName'){
        this.indexNameCount = this.utilService.getRecordsForIndexNameForEMIX(filter.indexName.join('~'), data).length;
      }
    });

    if (batchSub) {
      batchSub.unsubscribe();
    }
  }

  initialiseDropDowns(): void {
    this.refreshFilters = false;
    this.filter = {};
    this.families = {
      label: '',
      options: []
    };
    this.maturity = {
      label: '',
      options: []
    };
    this.rating = {
      label: '',
      options: []
    };
    this.currency = {
      label: '',
      options: []
    };
    this.fxVersion = {
      label: '',
      options: []
    };
    this.sector = {
      label: '',
      options: []
    };
    this.subSector = {
      label: '',
      options: []
    };
    this.region = {
      label: '',
      options: []
    };
    this.investmentType = {
      label: '',
      options: []
    };
  }

  storeFilters(event: any, id: string): void{
    this.filterMap = this.shareService.filteredMap;
    const filter = {};
    if (id === 'masterID' || id === 'indexName'){
      // @ts-ignore
      filter[id] = event;
    }else {
      // @ts-ignore
      filter[id] = event.map((item: any) => {
        if (id === 'maturity') { // @ts-ignore
          return this.maturityMapping[item.value];
        }
        if (id === 'region') {
          return item.value.split(' ').join('_');
        }
        if (id === 'investmentType') {
          return item.value.split('/').join('_').split(' ').join('_');
        }
        return item.value;
      }).join('~');
    }
    // @ts-ignore
    this.filterMap.set(id, filter[id]);
    this.shareService.filteredMap = this.filterMap;
  }

  applyFilter(event: any, id: string): void {
    this.storeFilters(event, id);
    this.shareService.filteredMap.forEach((value: string, key: string) => {
      // @ts-ignore
      this.filter[key] = value;
    });
    this.hasFilter = true;
    this.cleanUpFilter(this.filter);
    if (Object.keys(this.filter).length > 0) {
      this.shareFilter.emit(this.filter);
      this.updateResultCount();
      this.saveFilters(this.filterMap);
    } else {
      this.clearFilter();
    }
    // @ts-ignore
    // this.reInitiateInvestmentType(investmentTypeValues);
  }

  searchByMasterID(event: any): void{
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (event.key === 'Enter') {
        if (this.masterID.trim().length > 0){
          this.applyFilter(this.masterID.trim(), 'masterID');
        }
      }
    }, 100);
  }

  searchByIndexName(): void{
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.applyFilter(this.indexName.trim(), 'indexName');
    }, 100);
  }

  updateResultCount(): void {
    const subs = this.shareService.screenerFilters.subscribe((resp: any) => {
      this.getResultCount(resp, '');
    });

    if (subs) {
      subs.unsubscribe();
    }
  }

  cleanUpFilter(filter: any): void {
    Object.keys(filter).forEach((key: string) => {
      if (filter[key] === undefined || filter[key].length === 0) {
        delete filter[key];
        this.shareService.filteredMap.delete(key);
        this.getFilterForKey(key);
      }
    });
  }

  saveFilters(filter: any): void {
    const screenerFilter = new ScreenerFilter();
    filter.forEach((key: string, value: string) => {
      // @ts-ignore
      screenerFilter[value] = key;
    });
    this.updateFilter(screenerFilter);
  }

  clearFilter(): void {
    this.updateFilter(new ScreenerFilter());
    this.masterID = '';
    this.indexName = '';
    this.hasFilter = false;
    this.shareService.filteredMap.clear();
    this.filterStatus.emit(false);
    this.ngOnInit();
  }

  updateFilter(filter: any): void{
    const filters = new Filters();
    this.store.select(state => state.screenerFilters.screenerFilters).subscribe((resp: any) => {
      Object.keys(resp).forEach((key: string) => {
        if (key === this.indexType) {
          // @ts-ignore
          filters[key] = filter;
        }else{
          // @ts-ignore
          filters[key] = resp[key];
        }
      });
    });
    this.store.dispatch(new UpdateFilter(filters));
  }

  sortFilters(): void {
    if (this.currency) {
      this.currency.options.sort((op1: any, op2: any) => op1.label < op2.label ? -1 : 1);
    }
    if (this.fxVersion) {
      this.fxVersion.options.sort((op1: any, op2: any) => op1.label < op2.label ? -1 : 1);
    }
    if (this.sector) {
      this.sector.options.sort((op1: any, op2: any) => op1.label < op2.label ? -1 : 1);
    }
    if (this.subSector) {
      this.subSector.options.sort((op1: any, op2: any) => op1.label < op2.label ? -1 : 1);
    }
    if (this.rating) {
      this.rating.options.sort((op1: any, op2: any) => op1.label < op2.label ? -1 : 1);
    }
    if (this.families) {
      this.families.options.sort((op1: any, op2: any) => op1.label < op2.label ? -1 : 1);
    }
  }

  getValue(id: string): string {
    let result = '';
    switch (id) {
      case '(unassigned)':
        result = '(unassigned)';
        break;
      case 'years1To3':
        result = '1-3 years';
        break;
      case 'years1To5':
        result = '1-5 years';
        break;
      case 'years1To10':
        result = '1-10 years';
        break;
      case 'years1To15':
        result = '1-15 years';
        break;
      case 'years1To20':
        result = '1-20 years';
        break;
      case 'years3To5':
        result = '3-5 years';
        break;
      case 'years5To7':
        result = '5-7 years';
        break;
      case 'years5To10':
        result = '5-10 years';
        break;
      case 'years5To15':
        result = '5-15 years';
        break;
      case 'years5Plus':
        result = '5 years plus';
        break;
      case 'years7To10':
        result = '7-10 years';
        break;
      case 'years7Plus':
        result = '7 years plus';
        break;
      case 'years10To15':
        result = '10-15 years';
        break;
      case 'years10Plus':
        result = '10 years plus';
        break;
      case 'years15To20':
        result = '15-20 years';
        break;
      case 'years15To25':
        result = '15-25 years';
        break;
      case 'years15Plus':
        result = '15 years plus';
        break;
      case 'years20To25':
        result = '20-25 years';
        break;
      case 'years25To30':
        result = '25-30 years';
        break;
      case 'years25Plus':
        result = '25 years plus';
        break;
      case 'years30Plus':
        result = '30 years plus';
        break;
    }
    return result;
  }
}
